import React, { useEffect } from 'react';
import { signinSilentCallback } from 'shared/services/userService';
import { useNavigate } from 'react-router-dom';
import { Spinner } from '../components/ui/Spinner';

const SilentAuth = () => {
    const navigate = useNavigate();

    useEffect(() => {
        async function silentAuthAsync() {
            await signinSilentCallback();
        }

        silentAuthAsync();
    }, [navigate]);

    return (
        <div className="login-status">
            Signing in
            <Spinner />
        </div>
    );
}

export default SilentAuth;